import React, { useState } from 'react';
import './ReportLost.css';
import { db } from '../firebase/firebaseConfig';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const ReportLost = () => {
  const [formData, setFormData] = useState({
    itemName: '',
    dateReported: '',
    description: '',
    location: '',
    yourName: '',
    message: '',
    itemStatus: '',
    reportType: '',
  });

  const [imageFile, setImageFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      setImageFile(e.target.files[0]);
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      let imageBase64 = '';
      if (imageFile) {
        imageBase64 = await convertToBase64(imageFile);
      }

      const itemData = {
        ...formData,
        imageUrl: imageBase64,
        createdAt: Timestamp.now(),
        userEmail: currentUser?.email || '',
        claimed: false, 
      };

      const collectionName = formData.reportType === 'found' ? 'foundItems' : 'founditems';

      await addDoc(collection(db, collectionName), itemData);

      navigate('/client-dashboard', { state: { success: true } });
    } catch (error) {
      console.error('❌ Error submitting item report:', error);
      alert('❌ Failed to report item.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="report-lost-container">
      <h2>Report Item</h2>

      <form className="report-lost-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="itemName"
          placeholder="Item Name"
          value={formData.itemName}
          onChange={handleChange}
          required
        />
        <input
          type="date"
          name="dateReported"
          value={formData.dateReported}
          onChange={handleChange}
          required
        />
        <textarea
          name="description"
          placeholder="Item Description"
          value={formData.description}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="location"
          placeholder="Location Lost or Found"
          value={formData.location}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="yourName"
          placeholder="Your Name"
          value={formData.yourName}
          onChange={handleChange}
          required
        />
        <textarea
          name="message"
          placeholder="Any message (optional)"
          value={formData.message}
          onChange={handleChange}
        />

        <label>
          Item Status:
          <select
            name="itemStatus"
            value={formData.itemStatus}
            onChange={handleChange}
            required
          >
            <option value="">-- Select Status --</option>
            <option value="Lost">Lost</option>
            <option value="Found">Found</option>
          </select>
        </label>

        <label>
          Report Type:
          <select
            name="reportType"
            value={formData.reportType}
            onChange={handleChange}
            required
          >
            <option value="">-- Select Type --</option>
            <option value="lost">Lost (I'm the owner)</option>
            <option value="found">Found (I found it)</option>
          </select>
        </label>

        <label>
          Upload Image:
          <input type="file" accept="image/*" onChange={handleImageChange} />
        </label>

        <button type="submit" disabled={submitting}>
          {submitting ? 'Submitting...' : 'Submit'}
        </button>
      </form>
    </div>
  );
};

export default ReportLost;
